/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const AudioToTextIcon = createIcon(
  '0 0 20 20',
  <g>
    <path
      fillRule="evenodd"
      d="M15.629 17h-2.186l-.883-2.47H8.386L7.517 17H5.392L9.163 6.822h2.664zm-6.6-4.28h2.888l-1.452-4.086z"
      clipRule="evenodd"
    />
    <path d="M9 3v2.5L6 4.375V8a2 2 0 1 1-1-1.73V1.5z" />
  </g>,
);
